import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runMintTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    return runIndependentProductionTick(
        settlement,
        'mint',
        settlement.jobs.minters,
        settlement.production.mint.progress,
        config.production.mint.ticksPerBatch,
    );
}
